module.exports = __webpack_public_path__ + "img/if_7.be7fcada.png";